module.exports = __webpack_public_path__ + "static/media/carousel21.2bcc632c.jpg";